/** Search / filter bucket for in-app docs search (chips). */
export type DocsSearchKind = "faq" | "guide" | "screens";

export type DocsSearchScope = "all" | DocsSearchKind;

export function docsSearchKindFromHref(href: string): DocsSearchKind {
  if (href.startsWith("/docs/screens/")) return "screens";
  if (href.startsWith("/docs/faq/")) return "faq";

  return "guide";
}
